import { createStore, applyMiddleware,compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './combineReducer'
import { persistStore } from 'redux-persist'
import {configConstants} from '../Utils/utils'


const middleware = [
  thunk
];

const composeEnhancers =  configConstants.devTools || compose;


export default () =>{
  const store = composeEnhancers(applyMiddleware(...middleware))(createStore)(rootReducer);
  const persistor = persistStore(store)
  return { store, persistor};
}
